function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// /Users/hynek/Work/localhost/malcom/wp-content/themes/malcom/node_modules/@babel/runtime/helpers/assertThisInitialized.js
// module id = 28
// module chunks = 0